import { useEffect, useState } from "react";
import { KeyModuleScreen, IPropModuleContainer } from "@maysoft/common-component-react";

import MessageTemplateCaseEditContainer, { MessageTemplateCaseEditContainerProps } from "./edit";
import MessageTemplateCaseListContainer, { IMessageTemplateCaseListContainerProps } from "./list";
import { IRequestGetPagedMessageTemplateCase } from "../../services/message/MessageTemplateCase.service";



const ModuleMessageTemplateCase = (props: Omit<IPropModuleContainer<IRequestGetPagedMessageTemplateCase>, "onNavigate"> & IMessageTemplateCaseListContainerProps & MessageTemplateCaseEditContainerProps) => {

    const currentPath = window.location.pathname || "";

    const [idDetail, setIdDetail] = useState<string | undefined>(undefined);

    useEffect(() => { setIdDetail(props.idDetail); }, [props.idDetail]);

    const propsCopy = {
        mode: props.mode,
        idDetail: idDetail,
        onChangeMode: props.onChangeMode,
        detailInitialData: props.detailInitialData,
        onGoBack: () => {
            setIdDetail(undefined);
            props.onGoBack();
        },
    };

    const listContainers: { [key in KeyModuleScreen]?: JSX.Element; } = {
        "list": (
            <MessageTemplateCaseListContainer
                onGetPaged={props.onGetPaged}
                requestGetPaged={props.requestGetPaged}
                onNavigate={(data) => {
                    setIdDetail(data.id);
                    props.onNavigate(data);
                }}
            />
        ),
        "detail": (
            <MessageTemplateCaseEditContainer {...propsCopy} />
        ),
        "create": (
            <MessageTemplateCaseEditContainer {...propsCopy} />
        ),
        "update": (
            <MessageTemplateCaseEditContainer {...propsCopy} />
        ),
    };

    const renderContainerView = () => {
        const itemFind = Object.keys(props.keyModuleContainer).find((key) => ((props.keyModuleContainer as any)[key]?.pathName === currentPath));
        return (listContainers as any)[itemFind];
    };

    return <>{renderContainerView()}</>;
};

export default ModuleMessageTemplateCase;
